import React /* , { useEffect } */ from 'react';
// import { useLocation } from '@reach/router';
import PropTypes from 'prop-types';
import Layout from '../components/LayoutHome';

import Home from '../views/Home';

const WalletConnect = props => {
  const {
    pageContext: { locale },
    location: { pathname },
  } = props;
  // const location = useLocation();

  /*   useEffect(() => {
    try {
      window.location.href = `bitcoincom:/${location.pathname}${location.search}`;
    } catch (error) {
      console.log('no');
    }
  }, [location]);
 */
  return (
    <Layout locale={locale} localeDir={pathname}>
      <Home locale={locale} />
    </Layout>
  );
};

WalletConnect.propTypes = {
  pageContext: PropTypes.shape({
    locale: PropTypes.string,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default WalletConnect;
